import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getUserNoticeEvents} from '../../store/actions/userNoticesActions';
import Spinner from '../_common/Spinner';
import {actionLabel, phaseLabel} from './noticeHelpers';
import './UserNoticeDetailsModal.scss';

const selector = state => {
    const {language, userNotices} = state;
    return {
        t: language.translator,
        events: userNotices.events,
        eventsPending: userNotices.eventsPending,
        eventsTotalPages: userNotices.eventsTotalPages
    };
};

const formatTime = value => (value ? String(value).replace('T', ' ').substring(0, 16) : '-');

const UserNoticeDetailsModal = ({notice, closeMethod}) => {
    const {t, events, eventsPending, eventsTotalPages} = useSelector(selector);
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(0);

    useEffect(() => {
        dispatch(getUserNoticeEvents(notice.id, page));
    }, [dispatch, notice.id, page]);

    const eventLabel = type => ({
        SHOWN: t.gettext('Shown'),
        BLOCKED: t.gettext('Blocked request'),
        ACTION_CLICKED: t.gettext('Button pressed'),
        ACKNOWLEDGED: t.gettext('Confirmed by user')
    }[type] || type);

    return (
        <div
            className='userNoticeDetailsBlur'
            onClick={event => {
                if (event.target.className === 'userNoticeDetailsBlur') {
                    closeMethod();
                }
            }}
        >
            <div className='userNoticeDetailsWindow'>
                <div className='userNoticeDetailsHeader'>
                    {notice.campaignName || t.gettext('Message')} #{notice.id}
                    <button onClick={closeMethod} aria-label={t.gettext('Close')}>
                        <span className='material-icons'>close</span>
                    </button>
                </div>
                <div className='userNoticeDetailsSummary'>
                    <div>{t.gettext('Status')}: {notice.active ? phaseLabel(t, notice.phase) : t.gettext('Inactive')}</div>
                    <div>{t.gettext('Button')}: {actionLabel(t, notice)}</div>
                    <div>{t.gettext('Shown')}: {notice.shownCount}</div>
                    <div>{t.gettext('Blocked requests')}: {notice.blockedRequestCount}</div>
                    <div>{t.gettext('Blocking starts')}: {formatTime(notice.blockingStartsAt)}</div>
                    {notice.deactivationReason && <div>{t.gettext('Ended')}: {notice.deactivationReason}</div>}
                </div>
                <div className='userNoticeDetailsSubHeader'>{t.gettext('Event log')}</div>
                <div className='userNoticeDetailsEvents'>
                    {events.map(item => (
                        <div key={item.id} className='userNoticeDetailsEvent'>
                            <span>{formatTime(item.eventTime)}</span>
                            <span>{eventLabel(item.eventType)}</span>
                            <span className='userNoticeDetailsMuted'>{item.endpoint || ''}</span>
                        </div>
                    ))}
                    {!events.length && !eventsPending &&
                        <div className='userNoticeDetailsMuted'>{t.gettext('No events yet')}</div>
                    }
                    {eventsPending && <Spinner/>}
                </div>
                {page + 1 < eventsTotalPages && !eventsPending &&
                    <button className='userNoticeDetailsMore' onClick={() => setPage(page + 1)}>
                        {t.gettext('Load more')}
                    </button>
                }
            </div>
        </div>
    );
};

export default UserNoticeDetailsModal;
